import React, { useState } from 'react';
import { NavigationFooter } from './NavigationFooter';
import { MiniPlayer } from './MiniPlayer';
import { FullPlayer } from './FullPlayer';
import { MobileSearchSheet } from './MobileSearchSheet';
import { useSelectorWithRefresh } from '@/store/kysely_module';

const defaultArray: any[] = [];

export function MobileFooter() {
    const [isPlayerExpanded, setIsPlayerExpanded] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');

    const [searchResults, refreshSearchResults, isLoading] = useSelectorWithRefresh(
        'searchEverything',
        { query: searchQuery },
        defaultArray,
        { workspace_id: null }
    );

    const handleOpenSearch = () => {
        setIsSearchOpen(true);
        if (!searchQuery) {
            refreshSearchResults();
        }
    };

    return (
        <>
            <NavigationFooter
                isHidden={isPlayerExpanded}
                onOpenSearch={handleOpenSearch}
            />
            <MiniPlayer
                onExpand={() => setIsPlayerExpanded(true)}
                isExpanded={isPlayerExpanded}
            />
            <FullPlayer isOpen={isPlayerExpanded} onClose={() => setIsPlayerExpanded(false)} />
            <MobileSearchSheet
                isOpen={isSearchOpen}
                onClose={() => setIsSearchOpen(false)}
                searchQuery={searchQuery}
                onSearchChange={setSearchQuery}
                searchResults={searchResults || []}
                isLoading={isLoading}
            />
        </>
    );
}
